import moduleRepo from '../services/modules';

export const SET_ADMIN_MODULES_LIST              = 'SET_ADMIN_MODULES_LIST';
export const SET_ADMIN_MODULE_OVERLAY_MODE       = 'SET_ADMIN_MODULE_OVERLAY_MODE';
export const SET_ADMIN_MODULE_TO_EDIT            = 'SET_ADMIN_MODULE_TO_EDIT';
export const SET_ADMIN_MODULE_OVERLAY_VISIBILITY = 'SET_ADMIN_MODULE_OVERLAY_VISIBILITY';
export const SHOW_ADMIN_MODULE_DELETE_OVERLAY    = 'SHOW_ADMIN_MODULE_DELETE_OVERLAY';
export const HIDE_ADMIN_MODULE_DELETE_OVERLAY    = 'HIDE_ADMIN_MODULE_DELETE_OVERLAY';

export function setModules(modules) {

    return {
        type: 'SET_ADMIN_MODULES_LIST',
        modules
    };
}

export function setModuleToEdit(module) {

    return {
        type: 'SET_ADMIN_MODULE_TO_EDIT',
        module
    };
}

export function setModuleOverlayMode(mode) {

    return {
        type: 'SET_ADMIN_MODULE_OVERLAY_MODE',
        mode
    };
}

export function setModuleOverlayVisibility(isVisible) {

    return {
        type: 'SET_ADMIN_MODULE_OVERLAY_VISIBILITY',
        isVisible
    };
}

export function showDeleteOverlay(module) {

    return {
        type: 'SHOW_ADMIN_MODULE_DELETE_OVERLAY',
        module
    };
}

export function hideDeleteOverlay() {

    return {
        type: 'HIDE_ADMIN_MODULE_DELETE_OVERLAY'
    };
}

export function deleteModule(module) {

    return (dispatch) => {

        function deleteModuleSuccess() {

            dispatch(hideDeleteOverlay());
            dispatch(refreshModules());
        }
        
        moduleRepo.remove(module)
            .then(deleteModuleSuccess);
    }
}

export function refreshModules() {

    return (dispatch) => {

        function getModulesSuccess(response) {
            dispatch(setModules(response.data.data));
        }

        moduleRepo.getAll()
            .then(getModulesSuccess);
    }
}


// WEBPACK FOOTER //
// ./actions/moduleList.js